import { composeAutomationId } from '../automation-id.util';

export const ApplicationAutomationIds = {
  listCard: 'app-list-card',
  back: 'app-detail-back',
  settings: 'app-detail-settings',
  guardrails: 'app-detail-guardrails',
  tabOverview: 'app-detail-tab-overview',
  tabActivity: 'app-detail-tab-activity',
  tabFindings: 'app-detail-tab-findings',
  activitySubtabAssets: 'app-activity-subtab-assets',
  activitySubtabCode: 'app-activity-subtab-code',
  activitySubtabSignals: 'app-activity-subtab-signals',
  activityFilterRow: 'app-activity-filter-row',
  activityFilterCreatedAt: 'app-activity-filter-created-at',
  overviewViewTrends: 'app-detail-overview-view-trends',
  overviewViewCatchUp: 'app-detail-overview-view-catchup',
  assetsRoot: 'app-activity-assets',
  assetsFilterType: 'app-activity-assets-filter-type',
  assetsFilterVerified: 'app-activity-assets-filter-verified',
  assetsFilterCoverage: 'app-activity-assets-filter-coverage',
  assetsFilterMethods: 'app-activity-assets-filter-methods',
  assetsFilterRoles: 'app-activity-assets-filter-roles',
  assetsFilterState: 'app-activity-assets-filter-state',
  findingsFilterRow: 'app-findings-filter-row',
  findingsFilterSeverity: 'app-findings-filter-severity',
  findingsFilterStatus: 'app-findings-filter-status',
  findingsFilterHasPrevention: 'app-findings-filter-has-prevention',
  findingsFilterState: 'app-findings-filter-state',
  findingsFilterCreatedAt: 'app-findings-filter-created-at',
  assetsRefresh: 'app-activity-assets-refresh',
  assetsExportCsv: 'app-activity-assets-export-csv',
  assetsMappingHistoryOpen: 'app-activity-assets-mapping-history-open',
  assetsMappingHistoryDrawer: 'app-activity-assets-mapping-history-drawer',
  assetsKpiVulnerable: 'app-activity-assets-kpi-vulnerable',
  assetsKpiSensitive: 'app-activity-assets-kpi-sensitive',
  assetsKpiClear: 'app-activity-assets-kpi-clear',
  assetsMetricsSwitch: 'app-activity-assets-metrics-switch',
  assetsDetectionView: 'app-activity-assets-detection-view',
  assetsEndpointDrawer: 'app-activity-assets-endpoint-drawer',
  codeRoot: 'app-activity-code',
  codeFilterEntryPointTypes: 'app-activity-code-filter-entry-point-types',
  codeKpiRemediation: 'app-activity-code-kpi-remediation',
  codeRefresh: 'app-activity-code-refresh',
  codeMetricsSwitch: 'app-activity-code-metrics-switch',
  codeKpiEntryPoints: 'app-activity-code-kpi-entry-points',
  codeKpiReachable: 'app-activity-code-kpi-reachable',
  codeKpiSignals: 'app-activity-code-kpi-signals',
  codeAnalyzeNow: 'app-activity-code-analyze-now',
  codeAnalyzeNowDialog: 'app-activity-code-analyze-now-dialog',
  codeAnalyzeNowCancel: 'app-activity-code-analyze-now-cancel',
  codeAnalyzeNowConfirm: 'app-activity-code-analyze-now-confirm',
  codeEndpointDrawer: 'app-activity-code-endpoint-drawer',
  signalsRoot: 'app-activity-signals',
  signalsFilterState: 'app-activity-signals-filter-state',
  signalsFilterStage: 'app-activity-signals-filter-stage',
  signalsFilterStatus: 'app-activity-signals-filter-status',
  signalsFilterCategory: 'app-activity-signals-filter-category',
  signalsFilterOrigin: 'app-activity-signals-filter-origin',
  signalsFilterSource: 'app-activity-signals-filter-source',
  signalsRefresh: 'app-activity-signals-refresh',
  signalsExportCsv: 'app-activity-signals-export-csv',
  signalsImport: 'app-activity-signals-import',
  signalsImportDialog: 'app-activity-signals-import-dialog',
  signalsImportClose: 'app-activity-signals-import-close',
  signalsDomainTree: 'app-activity-signals-domain-tree',
  signalsHeader: 'app-activity-signals-header',
  signalsDrawer: 'app-activity-signals-drawer',
  signalsEmptyRetry: 'app-activity-signals-empty-retry',
  domainScopeColumnThirdParty: 'app-domain-scope-column-third-party',
  domainScopeColumnInteraction: 'app-domain-scope-column-interaction',
  domainScopeColumnAttack: 'app-domain-scope-column-attack',
  domainScopeThirdParty: 'app-domain-scope-third-party',
  domainScopeInteraction: 'app-domain-scope-interaction',
  domainScopeAttack: 'app-domain-scope-attack',
  domainScopeFirstEnableConfirm: 'app-domain-scope-first-enable-confirm',
} as const;

export type DomainScopeSwitchField = 'thirdParty' | 'interaction' | 'attack';

const DOMAIN_SCOPE_SWITCH_IDS: Record<DomainScopeSwitchField, string> = {
  thirdParty: ApplicationAutomationIds.domainScopeThirdParty,
  interaction: ApplicationAutomationIds.domainScopeInteraction,
  attack: ApplicationAutomationIds.domainScopeAttack,
};

export const applicationListCardId = (applicationId: string): string =>
  composeAutomationId(ApplicationAutomationIds.listCard, applicationId);

export const applicationAssetsCardId = (assetId: string) =>
  `app-activity-assets-card-${assetId}`;

export const applicationCodePrId = (pullNumber: number) =>
  `app-activity-code-pr-${pullNumber}`;

export const applicationCodeEntryPointId = (entryPointId: string) =>
  `app-activity-code-entry-point-${entryPointId}`;

export const applicationCodeEndpointId = (endpointId: string) =>
  `app-activity-code-endpoint-${endpointId}`;

export const applicationSignalsStageId = (stage: string) =>
  `app-activity-signals-stage-${stage}`;

export const applicationSignalsGroupId = (endpointId: string) =>
  `app-activity-signals-group-${endpointId}`;

export const applicationSignalsRowId = (signalId: string) =>
  `app-activity-signals-row-${signalId}`;

export const applicationDomainScopeSwitchId = ({
  field,
  host,
  path,
}: {
  field: DomainScopeSwitchField;
  host: string;
  path?: string;
}): string =>
  composeAutomationId(
    DOMAIN_SCOPE_SWITCH_IDS[field],
    path ? `${host}${path}` : host,
  );
